<script>
/**
 * ****************************************************************************
 * @description     :   Input Search Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import { mapMutations, mapState } from 'vuex';

import SamplePopupSearch from '@/views/popupSearch/samplePopupSearch';
import M903_201 from '@/views/popupSearch/M903_201';
import Suppliers from '@/views/popupSearch/Suppliers';
import Transportation from '@/views/popupSearch/Transportation';
import PopupArea from '@/views/popupSearch/popup_area';
import MobilePopup from '@/views/popupSearch/mobile_popup';
import PopupWidget from '@/views/popupSearch/popup_widget';
import Office from '@/views/popupSearch/popup_office';
import Branch from '@/views/popupSearch/popup_branch';
import Customer from '@/views/popupSearch/popup_customer';
import PopupMST007 from '@/views/popupSearch/PopupMST007';
import PopupSystem001 from '@/views/popupSearch/PopupSystem001';
import PopupMST050 from '@/views/popupSearch/PopupMST050';
import PopupMST004 from '@/views/popupSearch/PopupMST004';
import PopupMST005 from '@/views/popupSearch/PopupMST005';
import PopupMST006 from '@/views/popupSearch/PopupMST006';
import PopupMST008 from '@/views/popupSearch/PopupMST008';
import PopupMST012 from '@/views/popupSearch/PopupMST012';
import PopupMST013 from '@/views/popupSearch/PopupMST013';
import PopupMST001 from '@/views/popupSearch/PopupMST001';
import PopupMST002 from '@/views/popupSearch/PopupMST002';
import PopupMST003 from '@/views/popupSearch/PopupMST003';
import PopupFIL030 from '@/views/popupSearch/PopupFIL030';
import PopupOrder006 from '@/views/popupSearch/PopupOrder006';
import PopupOrder008 from '@/views/popupSearch/PopupOrder008';
import User from '@/views/popupSearch/popup_user';
import ResponsiblePerson from '@/views/popupSearch/popup_responsible_person';
import UserCustomer from '@/views/popupSearch/popup_user_customer';

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define content of input search component
 */
var AnsInputSearch = {
    template: template,
    components: {
        SamplePopupSearch,
        M903_201,
        Suppliers,
        Transportation,
        PopupArea,
        MobilePopup,
        PopupWidget,
        Office,
        Customer,
        PopupMST007,
        PopupSystem001,
        PopupMST050,
        PopupMST004,
        PopupMST005,
        PopupMST006,
        PopupMST008,
        PopupMST012,
        PopupMST013,
        PopupMST001,
        PopupMST002,
        PopupMST003,
        PopupFIL030,
        PopupOrder006,
        PopupOrder008,
        Branch,
        ResponsiblePerson,
        User,
        UserCustomer
    },
    props: {
        id: String,
        label: String,
        index: [String, Number],
        index2: Object,
        itemClass: {
            type: [String, Object],
            default: ''
        },
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        buttonId: String,
        isDisabledInput: {
            type: Boolean,
            default: false
        },
        isAlwaysEnable: {
            type: Boolean,
            default: false
        },
        isHidden: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        isShowClear: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: String,
        modelValue: String,
        dataExtra: [String, Number, Object],
        pageSearch: String,
        propertyForId: String,
        propertyForName: String,
        // popupName: String,
        isRequiredBackground: Boolean,
        isRequired: Boolean,
        isReadonly: {
            type: Boolean,
            default: true
        },
        isShowLabel: {
            type: Boolean,
            default: false
        },
        isShowFooter: {
            type: Boolean,
            default: false
        },
        isModalHeader: {
            type: Boolean,
            default: true
        },
        isDisabled: Boolean,
        isDisabledClear: Boolean,
        isWatchValue: {
            type: Boolean,
            default: false
        },
        onChange: Function,
        onChangeInput: Function,
        size: String,
        maxLength: Number,
        isShowCloseButton: {
            type: Boolean,
            default: true
        },
        autoClose: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array
        },
        type: {
            type: String,
            default: 'number'
        },
        popupParent: String
    },
    emits: ['update:modelValue', 'onReferValue', 'onReferValueName', 'onReferOtherName'],
    data() {
        return {
            newId: '',
            show: true,
            // popup: '',
            modeDisabled: false,
            popupInputSearchOpening: [],
            isPopupVisible: {},
            popupName: '', // Tên popup hiện tại
            popup: null, // Component của modal
            initData: {} // Dữ liệu khởi tạo của popup
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
        if (
            ![
                'CUS_Login',
                'MNG_Login',
                'CUS_System901',
                'CUS_System902',
                'MNG_System901',
                'MNG_System902',
                'MNG_Order001',
                'MNG_System002',
                'MNG_System004',
                'MNG_Order004',
                'MNG_File001',
                'CUS_Order021',
                'CUS_Billing001',
                'CUS_Client003',
                'CUS_Delivery001'
            ].includes(this.$route.name)
        ) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name) && !this.isAlwaysEnable;
        }

        // const vm = this;
        // let countLoop = 0;
        // const interval = setInterval(function () {
        //     if (vm.$refs['popupSearch_' + vm.newId]) {
        //         vm.$refs['popupSearch_' + vm.newId].addEventListener(
        //             'hidden.bs.modal',
        //             vm.hidePopup
        //         );
        //         vm.$refs['popupSearch_' + vm.newId].addEventListener(
        //             'show.bs.modal',
        //             vm.showPopup
        //         );
        //         clearInterval(interval);
        //         // console.log(this.pageSearch, countLoop, 'added event');
        //     }
        //     if (countLoop > 100) {
        //         clearInterval(interval);
        //         // console.log('cannot add event');
        //     }
        //     countLoop++;
        // }, 100);

        document.addEventListener('keydown', this.handleKeydown);
        // document.addEventListener('hidden.bs.modal', this.hiddenModal);
    },
    unmounted() {
        document.removeEventListener('keydown', this.handleKeydown);
        // document.removeEventListener('hidden.bs.modal', this.hiddenModal);
        // this.hidePopup();
    },
    computed: {
        ...mapState('app', ['footerModals']),
        lengthFooterModals() {
            return this.footerModals.length;
        },
        ...mapMutations('app', ['hideHeaderError']),
        vewValue() {
            if (this.modelValue) {
                return this.modelValue;
            }
            return '';
        },
        customizeItemClass() {
            const baseClass = {
                'item-component': true
            };

            const addClass = {};

            if (typeof this.itemClass === 'object' && this.itemClass !== null) {
                return { ...baseClass, ...addClass, ...this.itemClass };
            } else if (typeof this.itemClass === 'string' && this.itemClass) {
                return { ...baseClass, ...addClass, [this.itemClass]: true };
            }

            return { ...baseClass, ...addClass };
        },
        propertyId() {
            if (this.propertyForId) {
                return this.propertyForId;
            }
            return 'code';
        },
        propertyName() {
            if (this.propertyForName) {
                return this.propertyForName;
            }
            return 'name';
        },
        modalTitle() {
            // this.show = true;
            // if (this.popupName) {
            //     return this.popupName;
            // }
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'SamplePopupSearch':
                    return '検索画面';
                case 'M903_201':
                    return '商品一覧';
                case 'Suppliers':
                    return '取引先';
                case 'Transportation':
                    return '交通費';
                case 'PopupArea':
                    return '統括部';
                case 'MobilePopup':
                    return '統括部';
                case 'PopupWidget':
                    return 'ウィジェット選択';
                case 'Office':
                    return 'オフィス';
                case 'Customer':
                    return '会社';
                case 'PopupMST007':
                    return 'オフィス';
                case 'PopupSystem001':
                    return '会社';
                case 'PopupMST050':
                    return '最寄駅';
                case 'PopupMST004':
                    return 'センターマスタ';
                case 'PopupMST005':
                    return '統括部_新';
                case 'PopupMST006':
                    return 'グループ';
                case 'PopupMST008':
                    return '社員検索_①';
                case 'PopupMST012':
                    return '銀行';
                case 'PopupMST013':
                    return '銀行支店';
                case 'PopupMST001':
                    return 'お客様一覧';
                case 'PopupMST002':
                    return 'お客様拠点一覧';
                case 'PopupMST003':
                    return 'お客様担当者一覧';
                case 'PopupFIL030':
                    return 'スタッフ情報';
                case 'Branch':
                    return '拠点';
                case 'User':
                    return '社員検索';
                case 'ResponsiblePerson':
                    return '担当者';
                case 'UserCustomer':
                    return '社員ユーザ';
                case 'PopupOrder006':
                    return '見積-受注検索';
                case 'PopupOrder008':
                    return '受注-見積検索';
                default:
                    return '検索画面';
            }
        },
        realMaxLength() {
            return this.maxLength;
        },
        validateError() {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == this.id) {
                        message = item.message;
                    }
                });
            }
            return message;
        }
    },
    methods: {
        // ...mapActions('app', ['hideHeaderError']),
        /**
         * update value for input search
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, item);
            } else {
                this.$emit('update:modelValue', item);
            }
        },
        // closeModal() {
        //     if (this.autoClose) {
        //         this.$refs[`btnClose_${this.newId}`].click();
        //     }
        // },
        /**
         * click button open popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        openPopupInputSearch(inputSearchRef, btnOpenPopupRef) {
            localStorage.setItem('inputSearchFocus', inputSearchRef);
            localStorage.setItem('btnOpenPopup', btnOpenPopupRef);
            this.showPopupInputSearch(this.pageSearch, this.pageSearch, this.initData);
        },
        /**
         * show popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        showPopupInputSearch(popupName, popupComponent, initData = {}) {
            this.isPopupVisible = { ...this.isPopupVisible, [popupName]: true };
            this.popupName = popupName;
            this.popup = popupComponent;
            this.initData = initData;
            //
            document.body.style.overflow = 'hidden';
            this.$nextTick(() => {
                const enabledInputsAndSelects = document.querySelectorAll(
                    `#${popupName}.popup-overlay .popup-wrapper .popup-body input:not([disabled]), #${popupName}.popup-overlay .popup-wrapper .popup-body select:not([disabled])`
                );
                if (enabledInputsAndSelects.length > 0) {
                    enabledInputsAndSelects[0].focus();
                }
                // // add event
                // const popupSearch = document.querySelector(
                //     `#${popupName}.popup-overlay`
                // );
                // popupSearch.addEventListener('keydown', this.handleKeydown);
            });
        },
        /**
         * close popup
         * -----------------------------------------
         * @author : ManhND - 2024/09/10 - create
         * @params :
         * @access : private
         */
        closePopupInputSearch(popupName) {
            this.isPopupVisible = {
                ...this.isPopupVisible,
                [popupName]: false
            };
            // focus input
            let inputFocusRef = localStorage.getItem('inputSearchFocus');
            let btnOpenPopupRef = localStorage.getItem('btnOpenPopup');
            let inputFocus = this.$refs[`${inputFocusRef}`];
            document.body.style.overflow = 'unset';
            if (inputFocus != undefined) {
                this.$refs[`${btnOpenPopupRef}`].blur();
                inputFocus.focus();
            }
        },
        handleKeydown(event) {
            if (event.keyCode === 27) {
                const popups = document.querySelectorAll('.popup-overlay');
                if (popups.length > 0) {
                    const lastPopup = popups[popups.length - 1];
                    const popupName = lastPopup.getAttribute('popup-name');
                    const excludedPopups = ['PopupMail', 'PopupChangePassword', 'PopupNotify'];
                    if (!excludedPopups.includes(popupName)) {
                        this.closePopupInputSearch(this.popupName);
                    }
                    // if (popupName != 'PopupMail') {
                    //     this.closePopupInputSearch(this.popupName);
                    // }
                }
                // this.closeModal();
            }
        },
        // // hiddenModal() {
        // //     this.$refs['btn-open-modal'].blur();
        // //     let id = localStorage.getItem('inputSearchFocus');
        // //     let item = this.$refs[`${id}`];
        // //     if (item != undefined) {
        // //         item.focus();
        // //         localStorage.removeItem('inputSearchFocus');
        // //     }
        // // },
        /**
         * remove value for input search
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        clearInput() {
            if (this.onChange) {
                this.onChange(this.index2, this.modelValue, null);
            } else {
                this.$emit('update:modelValue', null);
            }
        },
        // hidePopup() {
        //     this.show = false;
        //     if (this.hideHeaderError) {
        //         this.hideHeaderError();
        //     }
        //     const els = document.getElementsByClassName('datalist-top');
        //     const length = els.length;
        //     for (let i = 0; i < length; i++) {
        //         els[i].style.paddingRight = null;
        //     }
        //     if (this.popupParent) {
        //         // popup Mail
        //         var id_name_popup = 'popupSearch_' + this.id;
        //         console.log(id_name_popup);
        //         document.getElementById('popupMailPopup').click();
        //         if (id_name_popup == 'popupSearch_user_code_popup') {
        //             setTimeout(() => {
        //                 document.querySelector('#user_code_popup').focus();
        //             }, 500);
        //         } else if (id_name_popup == 'popupSearch_user_code_2_popup') {
        //             setTimeout(() => {
        //                 document.querySelector('#user_code_2_popup').focus();
        //             }, 500);
        //         } else if (id_name_popup == 'popupSearch_customer_cd_popup') {
        //             setTimeout(() => {
        //                 document.querySelector('#customer_cd_popup').focus();
        //             }, 500);
        //         } else if (id_name_popup == 'popupSearch_area_cd_popup') {
        //             setTimeout(() => {
        //                 document.querySelector('#area_cd_popup').focus();
        //             }, 500);
        //         } else if (id_name_popup == 'popupSearch_area_cd_2_popup') {
        //             setTimeout(() => {
        //                 document.querySelector('#area_cd_2_popup').focus();
        //             }, 500);
        //         } else {
        //             setTimeout(() => {
        //                 document.querySelector('#branch_cd_popup').focus();
        //             }, 500);
        //         }
        //     }
        // },
        // showPopup() {
        //     this.popup = this.pageSearch;
        //     this.show = true;
        //     if (this.hideHeaderError) {
        //         this.hideHeaderError();
        //     }
        //     const paddingRight = window.innerWidth - document.body.clientWidth;
        //     if (paddingRight > 0) {
        //         const els = document.getElementsByClassName('datalist-top');
        //         const length = els.length;
        //         for (let i = 0; i < length; i++) {
        //             els[i].style.paddingRight = paddingRight + 'px';
        //         }
        //     }
        //     if (this.popupParent) {
        //         var id_name = 'popupSearch_' + this.id;
        //         var popup = document.getElementById(id_name);
        //         document.body.append(popup);
        //         popup.remove();
        //     }
        // },
        changeInput(e) {
            let value = e.target.value;
            if (!value.match('^[0-9]*$')) {
                e.target.value = '';
            } else {
                if (this.onChangeInput) {
                    this.onChangeInput(this.index, value);
                }
                this.$emit('update:modelValue', value);
            }
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        getRealMaxLength() {
            // let maxl = this.maxLength;
            // if (maxl == undefined || maxl == null) {
            //     switch (this.pageSearch) {
            //         case 'ra001800v':
            //             maxl = 100;
            //             break;
            //         case 'ra001900v':
            //             maxl = 200;
            //             break;
            //         default:
            //             maxl = 50;
            //     }
            // }
            return undefined;
        },
        onclickFooterButton(callback) {
            if (callback) {
                callback();
            }
            this.$refs['btnClose_' + this.newId]?.click();
        },
        inputKeydown(e) {
            if (this.type == 'number' || this.type == 'money' || this.type == 'measure' || this.type == 'postcode') {
                return this.inputOnlyNumber(e);
            }
            if (this.type == 'tel') {
                return this.inputOnlyTel(e);
            }
        },
        /**
         * event block key on input with type tel
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyTel(e) {
            if (
                !(
                    (!e.shiftKey && e.keyCode > 47 && e.keyCode < 58) ||
                    (!e.shiftKey && e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 107 ||
                    e.keyCode == 109 ||
                    (!e.shiftKey && e.keyCode == 189) ||
                    (e.shiftKey && e.keyCode == 57) ||
                    (e.shiftKey && e.keyCode == 48) ||
                    (e.shiftKey && e.keyCode == 187)
                )
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * event block key on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                (!this.isNegative && e.keyCode == 189) ||
                e.keyCode == 109
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        onReferModelValue(data) {
            if (this.isWatchValue) {
                this.$emit('onReferValue', data);
                return;
            }

            this.$emit('update:modelValue', data);
        },
        onReferValueName(data) {
            this.$emit('onReferValueName', data);
        },
        onReferOtherName(data) {
            this.$emit('onReferOtherName', data);
        }
    }
};
export default AnsInputSearch;
</script>
